import React from 'react';
import { ErrorMessage, Field } from 'formik';
import Proptypes from 'prop-types';
import { formErrorMessage } from './FormErrorMessage';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import styled from 'styled-components';
import { get } from 'lodash';
import StyledText from '../styledComponents/StyledText';

const FormikRangeSlider = ({
  name,
  showValue = false,
  rangeSlideDisabled = false,
  thumbsDisabled = [false, false],
  singleThumb = false,
  showLabel = true,
  stepThreshold,
  ...props
}) => {
  return (
    <Field name={name}>
      {({ field, form: { submitCount, setFieldValue } }) => {
        const handleInput = (newValue) => {
          setFieldValue(field.name, newValue);
        };

        return (
          <StyledRangeContainer>
            <div className="d-flex  flex-column">
              <RangeSlider
                id={`range-slider-${name}`}
                min={props.min || 0}
                max={props.max || 100}
                value={field.value}
                onInput={handleInput}
                thumbsDisabled={thumbsDisabled}
                rangeSlideDisabled={rangeSlideDisabled}
                {...(singleThumb ? { className: 'single-thumb' } : {})}
                {...(stepThreshold ? { step: stepThreshold } : {})}
              />
              {showValue && (
                <div className="selectedValue mt-2 rounded-2">
                  {get(field, 'value[1]') || 0}
                </div>
              )}

              {showLabel && (
                <div className="d-flex justify-content-between mt-1">
                  <StyledText
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    color={'bodyMedium'}
                  >
                    {props.min}
                  </StyledText>
                  <StyledText
                    $fontSize={'18px'}
                    $fontWeight={'500'}
                    color={'bodyMedium'}
                  >
                    {props.max}
                  </StyledText>
                </div>
              )}
            </div>
            {submitCount > 0 && (
              <ErrorMessage name={field.name} render={formErrorMessage} />
            )}
          </StyledRangeContainer>
        );
      }}
    </Field>
  );
};

const StyledRangeContainer = styled.div`
  .selectedValue {
    width: fit-content;
    padding: 2px 7px;
    font-size: 14px;
    background-color: ${({ theme }) => theme.white};
    font-weight: bold;
  }
  .single-thumb {
    .range-slider__thumb[data-lower] {
      width: 0;
    }
    .range-slider__range {
      border-radius: 6px;
    }
  }
  .range-slider {
    .range-slider__range,
    .range-slider__thumb {
      background: ${({ theme }) => theme.primary} !important;
    }
    .range-slider__thumb {
      width: 18px;
      height: 18px;
    }
  }
`;
FormikRangeSlider.propTypes = {
  name: Proptypes.string.isRequired,
  placeholder: Proptypes.string,
  type: Proptypes.string,
  as: Proptypes.string,
  rows: Proptypes.string,
};
export default FormikRangeSlider;
